import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiReturnEnterPhoneData,
  type EnrollmentMultiReturnEnterPhoneSubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiReturnEnterPhoneDataMock: EnrollmentMultiReturnEnterPhoneData = {
  error: null,
  nextStep: 'SUBMIT_PHONE',
}

export const submitEnrollmentMultiReturnEnterPhoneDataMock: EnrollmentMultiReturnEnterPhoneSubmitOutput = {
  error: null,
  nextStep: 'VERIFY_PHONE',
}

export const mockGetEnrollmentMultiReturnEnterPhoneData = graphql.mutation(
  'getEnrollmentMultiReturnEnterPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: getEnrollmentMultiReturnEnterPhoneDataMock } })
  },
)

export const mockSubmitEnrollmentMultiReturnEnterPhoneData = graphql.mutation(
  'submitEnrollmentMultiReturnEnterPhoneData',
  () => {
    return HttpResponse.json({ data: { enterApplication: submitEnrollmentMultiReturnEnterPhoneDataMock } })
  },
)

export const mockEnrollmentMultiReturnEnterPhone = [
  mockGetEnrollmentMultiReturnEnterPhoneData,
  mockSubmitEnrollmentMultiReturnEnterPhoneData,
]
